export const slides = [
  {
    image: "/images/1.png",
    title: "Manage Inventory Easily",
    description: "Track product stock, expiry dates and restock alerts.",
  },
  {
    image: "/images/2.png",
    title: "Sales & Analytics",
    description: "View insightful dashboards and measure store performance.",
  },
  {
    image: "/images/3.png",
    title: "Smart Notifications",
    description: "Stay ahead with sales and inventory alerts in real time.",
  },
];

export const registrationSlides = [
  {
    image: "/images/1.png",
    title: "Manage Inventory Easily",
    description: "Track product stock, expiry dates and restock alerts.",
  },
  {
    image: "/images/2.png",
    title: "Sales & Analytics",
    description: "View insightful dashboards and measure store performance.",
  },
  {
    image: "/images/3.png",
    title: "Smart Notifications",
    description: "Stay ahead with sales and inventory alerts in real time.",
  },
  {
    image: "/images/4.png",
    title: "Smart Notifications",
    description: "Stay ahead with sales and inventory alerts in real time.",
  },
  {
    image: "/images/5.png",
    title: "Smart Notifications",
    description: "Stay ahead with sales and inventory alerts in real time.",
  },
]